export enum TipoOrganizacao {
    publico = 'PUBLICO',
    privado = 'PRIVADO',
}